import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const ConfirmationModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title, 
    message, 
    showReasonInput, 
    isAlert, 
    children, 
    noAutoClose, 
    disableOKButton, 
    hideDefaultActions 
}) => {
    const { t } = useTranslation();
    const [reason, setReason] = useState('');

    useEffect(() => {
        if (isOpen && isAlert && !noAutoClose) {
            const timer = setTimeout(() => {
                if (onClose) onClose();
            }, 3000); // Auto close after 3 seconds
            return () => clearTimeout(timer);
        }
    }, [isOpen, isAlert, onClose, noAutoClose]);

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (isOpen) {
                e.preventDefault();
                e.returnValue = ''; // Messaggio standard del browser
            }
        };

        if (isOpen) {
            window.addEventListener('beforeunload', handleBeforeUnload);
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const handleConfirm = () => {
        if (onConfirm) onConfirm(reason);
        setReason('');
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content card">
                <h3>{title}</h3>
                {message && <p>{message}</p>}
                {children && <div className="modal-custom-content" style={{ marginTop: '15px', marginBottom: '15px' }}>{children}</div>}
                {showReasonInput && (
                    <textarea
                        placeholder={t('reason_placeholder')}
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        className="reason-input"
                        rows={3}
                        style={{ width: '100%', marginTop: '10px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '4px', padding: '10px' }}
                    />
                )}
                {!hideDefaultActions && (
                    <div className="modal-actions">
                        {!isAlert && (
                            <button className="secondary-btn" onClick={onClose}>
                                {t('cancel')}
                            </button>
                        )}
                        {!disableOKButton && (
                            <button className="primary-btn" onClick={isAlert ? onClose : handleConfirm}>
                                {isAlert ? t('ok') : t('confirm')}
                            </button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ConfirmationModal;
